export default "__VITE_ASSET__4076fc35__"